import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
const SidebarFooter = ({ footer, className = '' }) => {
    if (!footer) {
        return null;
    }
    const footerClassNames = classNames('SidebarFooter', className);
    return _jsx("div", Object.assign({ className: footerClassNames }, { children: footer }));
};
export default SidebarFooter;
